/**
 * @generated SignedSource<<c748660e5d9f8d06cfe71d5cd327dc23>>
 * @relayHash 1b16cfbd440faa1f19fb1d609513974e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 153e29a99a7458df60953da76939d9c1009e135046e357ddfa8ee888dae04103

import type { ConcreteRequest } from 'relay-runtime';
export type GoalTqlExplainerAggQuery$variables = {
  containerId: string;
  directoryViewId?: string | null;
  hasTqlOrViewUuid: boolean;
  searchString: string;
};
export type GoalTqlExplainerAggQuery$data = {
  readonly goals_explainSearch?: {
    readonly explanation: string | null;
  } | null;
};
export type GoalTqlExplainerAggQuery = {
  response: GoalTqlExplainerAggQuery$data;
  variables: GoalTqlExplainerAggQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "directoryViewId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasTqlOrViewUuid"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchString"
},
v4 = [
  {
    "condition": "hasTqlOrViewUuid",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "containerId",
            "variableName": "containerId"
          },
          {
            "kind": "Variable",
            "name": "directoryViewId",
            "variableName": "directoryViewId"
          },
          {
            "kind": "Variable",
            "name": "searchString",
            "variableName": "searchString"
          }
        ],
        "concreteType": "TownsquareSearchExplanation",
        "kind": "LinkedField",
        "name": "goals_explainSearch",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "explanation"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "GoalTqlExplainerAggQuery",
    "selections": (v4/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "GoalTqlExplainerAggQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "id": "153e29a99a7458df60953da76939d9c1009e135046e357ddfa8ee888dae04103",
    "metadata": {},
    "name": "GoalTqlExplainerAggQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "bccedb13cb3cfe80630299f508752ac2";

export default node;
